import React, { useCallback } from 'react';
import { BaseEditable } from '@fmcc-web-platform/react-components';
import { MfeContextProvider } from '@quantum/tools/context';
import { MarkerProps } from '../types/Tile';
import { useCacheId } from '../hooks/useCacheId';
import { useDelayAnalytics } from '../hooks/useDelayAnalytics';
import { triggerMfeView } from '../../../utils/analytics';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const withCustomMarker = (Component: React.FC<any>) => {
  const WrappedComponent = (props: { model: MarkerProps } & BaseEditable) => {
    let customProps = useDelayAnalytics(props);
    customProps = useCacheId(customProps);
    const onReady = useCallback(() => {
      const moduleName = props.model.markerModule?.replace('./', '') ?? '';
      triggerMfeView(`${props.model.markerName}-${props.model.markerScope}-${moduleName}`, props.model.markerName ?? '');
    }, [props.model.markerName, props.model.markerScope, props.model.markerModule]);

    return (
      <MfeContextProvider onReady={onReady}>
        <Component
          {...customProps}
          {...customProps.model}
        />
      </MfeContextProvider>
    );
  };
  WrappedComponent.displayName = `withCustomMarker(${Component.displayName || Component.name})`;
  return WrappedComponent;
};

export default withCustomMarker;
